<template>
  <div slot="footer" style="margin-top:10px">
    <b-button
      v-if="showTop10"
      :disabled="!disabledAll"
      class="btn-outline"
      variant="outline-primary"
      left
      @click="$emit('top-10-all-data-emit', !disabledAll), changeDisabled()"
      >Top 10</b-button
    >

    <b-button
      v-if="showAll"
      :disabled="disabledAll"
      class="btn-outline float-right"
      variant="outline-primary"
      right
      @click="$emit('top-10-all-data-emit', !disabledAll), changeDisabled()"
      >All Data</b-button
    >

    <b-button
      v-if="showOverall"
      class="btn-outline text"
      style="margin-right:10px; float:right"
      variant="outline-primary"
      @click="() => $router.push(overallUrl)"
      >Overall Data</b-button
    >
  </div>
</template>

<script>
export default {
  name: "FooterOptions",
  props: ["showTop10", "showOverall", "showAll", "overallUrl", "disabled"],
  data: function() {
    return {
      disabledAll: false
    };
  },
  methods: {
    changeDisabled() {
      this.disabledAll = !this.disabledAll;
    }
  }
};
</script>
